import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AdAttributes, MicrosoftOnPremAdAttributesFieldConfig } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MicrosoftOnPremAdResource {
  private http = inject(HttpClient);

  getOnPremAttributesFieldConfig(
    tenantId: string | number,
    did: string,
    extension?: string,
  ): Observable<MicrosoftOnPremAdAttributesFieldConfig> {
    const params = new URLSearchParams(
      extension
        ? {
            did,
            ext: extension,
          }
        : { did },
    );
    const path = `/services/microsoft/field-configs/tenants/${tenantId}/on-prem-ad-attributes?${params.toString()}`;

    return this.http.get<MicrosoftOnPremAdAttributesFieldConfig>(path);
  }

  getAdAttributes(tenantId: string | number, upn: string, dialPlanId: number): Observable<AdAttributes> {
    return this.http.get<AdAttributes>(
      `/services/microsoft/macs/tenants/${tenantId}/on-prem-ad-attributes/${upn}/dial-plans/${dialPlanId}`,
    );
  }

  putAdAttributes(tenantId: string | number, upn: string, dialPlanId: number, body: AdAttributes): Observable<void> {
    return this.http.put<void>(
      `/services/microsoft/macs/tenants/${tenantId}/on-prem-ad-attributes/${upn}/dial-plans/${dialPlanId}`,
      body,
    );
  }
}
